import { jsx as _jsx } from "react/jsx-runtime";
export default function WidgetLoader(_a) {
    var loaderContainerClasses = _a.loaderContainerClasses, loaderClasses = _a.loaderClasses;
    return (_jsx("div", { className: "loader-position", children: _jsx("div", { className: loaderContainerClasses, children: _jsx("div", { className: "".concat(loaderClasses, " content-loader") }) }) }));
}
